import { VisibilityHandler } from './components/visibility-handler'
import { useIsDesktopSize } from '$common/react-hooks/layout'
import { ProfileCompletionModal } from '$comp/modals/profile-completion'

export function SjfSignup() {
  const isDesktopSize = useIsDesktopSize()

  if (isDesktopSize) return <ProfileCompletionModal />
  return (
    <VisibilityHandler zIndex={3}>
      <ProfileCompletionModal />
    </VisibilityHandler>
  )
}
